import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../../../models/filter.model";

@Component({
  selector: 'app-support-page-filter',
  templateUrl: './support-page-filter.component.html',
  styleUrls: ['./support-page-filter.component.scss']
})
export class SupportPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined
  @Input() filterSupportTypes: FilterModelDto[] | undefined

  filterStart: FilterModelDto = {
    fieldName: 'date_from',
    value: '',
    description: ''
  }

  filterEnd: FilterModelDto = {
    fieldName: 'date_to',
    value: '',
    description: ''
  }
}
